export default {
      id: "icon-noise-emission-usage",
      viewBox: "0 0 254 213",
      url: "/" + "sprite.svg#icon-noise-emission",
      toString: function () {
        return this.url;
      }
    }